"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionRole = void 0;
var create_entity_1 = require("../../utils/create-entity");
var entity_role_card_1 = require("../../components/entities/entity-role-card");
var graphql_1 = require("../../utils/graphql");
exports.SessionRole = {
  name: 'SessionRole',
  components: {
    card: entity_role_card_1.EntityRoleCard
  },
  table: {
    fieldNames: ["session", "person", "role"]
  },
  autoRoutes: ['create', 'update', 'list', 'details'],
  list: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    role { id name slug }\n    person { \n      id name type slug isDraft isPublished\n      bio { id plainTruncated: plain(truncate: { words: 60 }) }\n      organisation { id name slug }\n      photo { id url thumbnails { id full { id url width height } } }\n      location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n    }\n  "], ["\n    role { id name slug }\n    person { \n      id name type slug isDraft isPublished\n      bio { id plainTruncated: plain(truncate: { words: 60 }) }\n      organisation { id name slug }\n      photo { id url thumbnails { id full { id url width height } } }\n      location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n    }\n  "])))
  },
  form: {
    bufferAtEnd: 300,
    modal: {
      maxWidth: '700px'
    },
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      session: {
        type: 'linkedMultiple',
        required: true,
        focus: true,
        entityTypeName: 'Session',
        variant: 'forPerson'
      },
      person: {
        type: 'linkedMultiple',
        required: true,
        focus: true,
        entityTypeName: 'Person',
        variant: 'forSession'
      },
      role: {
        type: 'linked',
        entityTypeName: 'Role'
      }
    })
  }
};
var templateObject_1;